import styles from './full-bleed-background.module.scss';

const FullBleedBackground = () => {
  return <div className={styles.container}></div>;
};

export default FullBleedBackground;
